var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',[_c('router-view')],1),_c('Alert'),_c('LoginRequest'),_c('TokenRefresh'),_c('Snackbar'),_c('MessageGeneral')],1)}
var staticRenderFns = []

export { render, staticRenderFns }